const moveDynamicCartButtons = () => {
  const editButtons = document.querySelectorAll('.key-cart-edit-btn');
  
  editButtons.forEach(button => {
    // Safety check: stop if the button is already inside the title div
    if (button.parentElement.classList.contains('mini-cart__item-title')) return;
    
    // Find the main list item wrapper for this specific product in the cart
    const parentContainer = button.closest('.mini-cart__item'); 
    
    if (parentContainer) {
      // Find the specific title div within this item
      const targetDiv = parentContainer.querySelector('.mini-cart__item-title');
      
      if (targetDiv) {
        // Move the button to the bottom of the title div
        targetDiv.appendChild(button);
      }
    }
  });
};

// Set up the MutationObserver to watch for dynamic app injections
const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      moveDynamicCartButtons();
    }
  }
});

// Observe the entire body for changes
observer.observe(document.body, { 
  childList: true, 
  subtree: true 
});

// Run it once immediately on load just in case the button renders right away
moveDynamicCartButtons();